module.exports = __webpack_public_path__ + "img/t4-i20.25b32b67.jpg";